import { React, useEffect, useRef } from "react";
import EditButton from "../../components/buttons/EditButton";
import { handleQuestionInput, EditableContentCreate } from "../edit_quiz_helper/EditQuizHelper.jsx";
import { GenaiUrl, CreateQuizUrl } from "../../libs/env";
const Question = ({
  Questionedit,
  qai,
  data,
  counter,
  title,
  counterClass,
  showNumbers,
  alignement,
  myClassName,
  DisableQuestionNumbering,
  setQuestionedit,
  onUpdate,
  quesRef,
  isBlinking,
  focusblink,
  blurblink,
  setIsBlinking
}) => {
  const parentRef = useRef(null);

  const handleSaveClick = () => {
    const editableElements = document.querySelectorAll('.editable');
    editableElements.forEach(element => {
      element.contentEditable = 'false';
    });
  };
  useEffect(() => {

    const editableTags = parentRef.current.querySelectorAll('.editable');
    if (editableTags) {
      const editableArray = Array.from(editableTags);
      editableArray.forEach((tag,index) => {
        tag.addEventListener('input', (event) => {
          handleQuestionInput({
                    type: "question",
                    key: qai,
                    quizdata: data,
                    target: event.target.innerHTML,
                    tagindex: index,
                  });
        });
      });
    }
  }, [qai, data,Questionedit]);
  return (
    <div className="d-flex align-items-start">
      {showNumbers && (
        <span
          className={
            alignement === "Top"
              ? " d-flex align-self-top"
              : alignement === "Center"
              ? " d-flex align-self-center"
              : " d-flex align-self-end"
          }
        >
          {!DisableQuestionNumbering && (
            <strong className={counterClass}> {counter} </strong>
          )}
        </span>
      )}
      <span
        ref={parentRef}
        onFocus={focusblink}
        onBlur={blurblink}
        spellcheck="false" 
        data-gramm="false"
        className={`w-100 editquestions ${myClassName}`}
      >
      { qai === 0 && (window.location.pathname.includes(GenaiUrl) || window.location.pathname.includes(CreateQuizUrl)) ? (
      <div id="edit_btn" style={{float: "right"}}>
        {Questionedit ?
          (<EditButton
          label="Save"
            onClick={() => {
              setQuestionedit(false);
              onUpdate(data)
              setIsBlinking(false);
              handleSaveClick();
            }}
          />):
          (
            <EditButton
            label="Edit"
            onClick={() => {
              setQuestionedit(true);
              setIsBlinking(true);
              EditableContentCreate();
            }}
        />
          )
        }
      </div>):null}
      
        {title}
      { isBlinking && qai === 0 &&(<span className="blink-icon"></span>)}
      </span>
    </div>
  );
};

export default Question;
